module.exports = __webpack_public_path__ + "img/face.549659a5.png";